import * as MaterialIcons from '@mui/icons-material';

export const isIconValid = (icon) => {
    return !!MaterialIcons?.[icon];
};